function isNumber(test: any): test is Number {
    return (
        typeof test === 'number' && !Number.isNaN(test) && Number.isFinite(test)
    );
}

export default isNumber;
